import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CustomerSupportRepository } from '../repositories/customer-support.repository';
import { ContactFormInformationResponse } from '../models/ContactFormInformationResponse-response.model';

export class GetContactFormInformationUseCase
    implements UseCase<never, ContactFormInformationResponse>
{
    constructor(private readonly repository: CustomerSupportRepository) {}

    execute(): Observable<ContactFormInformationResponse> {
        return this.repository.getContactFormInformation();
    }
}
